import React, { useState, useEffect } from 'react';
import { BASE_URL, HOST_URL } from "../Dashboard/api/Api";
import Axios from "axios";
import MobileVerification from './MobileVerification';
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { FaLinkedin } from "react-icons/fa";

const GoogleLinkedinLogin = ({ redirectPath, page_name  }) => {
    const [token, setToken] = useState("");
    const [decodedToken, setDecodedToken] = useState(null);
    const [showMobileVerification, setShowMobileVerification] = useState(false);
    const [loginMessage, setLoginMessage] = useState('');
    const [bgColor, setBgColor] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [method, setMethod] = useState("");
    // const [redirectAfterLogin, setRedirectAfterLogin] = useState(null);

    // useEffect(() => {
    //     const params = new URLSearchParams(window.location.search);
    //     const ref = params.get("ref");
    //     if (ref) {
    //         setRedirectAfterLogin(ref);
    //     }
    // }, []);

    const handleGoogleLogin = async (data) => {
        const jwtToken = data.credential;
        setToken(jwtToken)
        try {
            const response = await Axios.post(`${HOST_URL}/login_socialmedia.php`, {
                method: 'gmail_login',
                jwt_token: jwtToken,
                page_name: page_name || "",
            });

            const responseData = response.data;

            if (responseData.success) {

                localStorage.setItem('login', JSON.stringify(responseData));
                localStorage.setItem('admin', JSON.stringify({ success: false }));

                // const loginType = responseData.user && responseData.user.login_type;
                // const redirectTo = loginType === 0
                //     ? "/signup-success"
                //     : "/dashboard";

                const redirectTo = redirectPath || "/dashboard";

                setTimeout(() => {
                    if (redirectTo === "/dashboard/whatsapp-onboarding-new") {
                        window.open(redirectTo, "_blank");
                    } else {
                        window.location.href = redirectTo;
                    }
                }, 1000);
            } else if (
                responseData.success === false &&
                responseData.message === 'enter_mobile'
            ) {
                setShowMobileVerification(true);
                setMethod("gmail_login")
            } else {
                setLoginMessage(responseData.message || 'Google login failed');
                setBgColor('alert alert-danger');
                setShowAlert(true);
            }
        } catch (error) {
            setLoginMessage('Google login error');
            setBgColor('alert alert-danger');
            setShowAlert(true);
        }
    };

    const handleLinkedInLogin = (e) => {
        e.preventDefault();

        const params = new URLSearchParams({
            response_type: 'code',
            client_id: '86f39wl0m4cpha',
            redirect_uri: 'http://localhost:3001/login/linkedin',
            scope: 'openid email profile',
        });

        window.location.href = `https://www.linkedin.com/oauth/v2/authorization?${params.toString()}`;
    };

    return (
        <>
            <div className="col-md-12">
                <GoogleOAuthProvider clientId="1035946222897-cbgbn4ohg19ia9dqoluq5bo392f1or7m.apps.googleusercontent.com">
                    <GoogleLogin
                        onSuccess={handleGoogleLogin}
                        onError={() => {
                            setLoginMessage("Google Login Failed");
                            setBgColor('alert alert-danger');
                            setShowAlert(true);
                        }}
                        text="continue_with"
                    />
                </GoogleOAuthProvider>
            </div>


            {/* <div className="col-md-12 mt-2">
                <button
                    className="btn btn-outline-primary w-100 d-flex align-items-center justify-content-center position-relative"
                    onClick={handleLinkedInLogin}
                    style={{
                        fontSize: "14px",
                        height: "40px",
                        fontFamily: "'Google Sans', sans-serif",
                        paddingLeft: "40px",
                    }}
                    aria-label="Continue with LinkedIn"
                >
                    <FaLinkedin
                        style={{
                            position: "absolute",
                            left: "12px",
                            fontSize: "22px",
                        }}
                    />
                    <span>Continue with LinkedIn</span>
                </button>
            </div> */}

            {showMobileVerification && <MobileVerification jwt={token} method={method} />}
        </>
    );
};

export default GoogleLinkedinLogin;
